export default __webpack_public_path__ + "static/media/icons-three-dots.84b97560.svg";